// public-search-utils.js

import {get} from 'svelte/store';
import {TCARE_TAX_1, OPEN_ELIG_2022, DEMOGRAPHICS} from "./taxonomy-classes.js";
// import { searchPublicServices } from "../api/services.ts";
import {delimitArray, dedupeSimpleArray} from "./utils.js";
import {AccountStore} from "./account";

const SEARCH_LIMIT = 1000;

// currently this is called from both the PublicLandingPage and the PublicResourcesPage
// clears out search.postalResults[] and then fills them with index records
// IMPORTANT - also maps serviceIds from results to the TaxonomyMenu
export const runPublicPostalSearch = async (searchStore) => {
    // console.log('public-search-utils.js - runPublicPostalSearch');

    let search = get(searchStore);
    let account = get(AccountStore);
    let usePublic = !account?.isLoggedIn;
    // this must be a public call that can return many index records (10K limit)

    let results = await search.runSearch(SEARCH_LIMIT, usePublic);       // true means public, use private if available
    if (results.errors) {
        // return false;                                               // show Alert on host page?
        return results;
    }
    searchStore.set(search);                                        // cannot use $ sytax here

    // API results are now in search.postalResults[]
    mapSearchResultsToOpenElig2022NodeServiceIds(searchStore);
    // return true;
    return {'errors': false};
}


// must be called after the public search is run
// map the serviceIds once after results are returned - not in real time!
// 06/10 - services are added to each node down the path - not just the exact match
// 06/16 - WARNING! not all of these will contain 'open-eligibility-2022' keywords!
export const mapSearchResultsToOpenElig2022NodeServiceIds = (searchStore) => {
    // console.log('mapSearchResultsToOpenElig2022NodeServiceIds');
    // console.log('redrawing taxonomy menu');

    const search = get(searchStore);                                // must access the store data
    let resultOpenElig = null;                                      // array of keywords on each result
    let node = null;                                                // where in the menu this keyword is
    let nodes = [];

    search.taxonomies[OPEN_ELIG_2022].clearServiceIds();            // new 06/14

    // iterate each result (service index) scanning for OPEN_ELIG_2022 keywords
    for (const result of search.postalResults) {
        // injectFakeOpenElg(result);                                  // REMOVE THIS!!!
        // injectFakeDemographics(result);                             // REMOVE THIS!!!
        if (result.taxonomies && result.taxonomies[OPEN_ELIG_2022]) {
            resultOpenElig = dedupeSimpleArray(result.taxonomies[OPEN_ELIG_2022]);     // ['food', 'meals', 'free meals']

            // new 6/27 - must map to multiple nodes, not just the first found!
            for (const keyword of resultOpenElig) {
                nodes = search.taxonomies[OPEN_ELIG_2022].findNodesByKeyword(keyword);
                for (const node of nodes) {
                    node.serviceIdsCount = 0;
                    if (!node.serviceIds) node.serviceIds = [];
                    if (!node.serviceIds.includes(result['service-id'])) {
                        node.serviceIds.push(result['service-id']);     // add service id to this node - only once
                        node.serviceIdsCount = node.serviceIds.length;
                    }
                }
            }

        }
    }
    // console.log('mapSearchResultsToOpenElig2022NodeServiceIds COMPLETED');
    // mapServiceIdCounts(searchStore);
}


// called from the PublicResourcesPage
// generic - should return a more restricted result set
// the main "postal" search result set remains intact
export const runPublicFilterSearch = async (searchStore) => {
    // console.log('public-search-utils.js - runPublicFilterSearch');

    let search = get(searchStore);
    let account = get(AccountStore);
    let usePublic = !account?.isLoggedIn;
    let results = await search.runFilterSearch(SEARCH_LIMIT, usePublic);         // true means public
    if (results.errors) {
        // return false;                                                       // show Alert on host page?
        return results;
    }
    searchStore.set(search);                                                // refresh - cannot use $ sytax here

    // API results are now in search.filterResults[]
    // return true;
    return {'errors': false};
}


export const runPublicDemographicsSearch = async (searchStore) => {
    // console.log('public-search-utils.js - runPublicDemographicsSearch');

    let search = get(searchStore);
    let account = get(AccountStore);
    let usePublic = !account?.isLoggedIn;
    let results = await search.runDemographicSearch(SEARCH_LIMIT, usePublic);         // true means public
    if (results.errors) {
        // return false;                                                       // show Alert on host page?
        return results;
    }
    searchStore.set(search);                                                // refresh - cannot use $ sytax here

    // API results are now in search.filterResults[]
    // return true;
    return {'errors': false};
}


// new 11/24/2022
export const runPublicSortSearch = async (searchStore, sortField, isAscending) => {

    let search = get(searchStore);
    let account = get(AccountStore);
    let usePublic = !account?.isLoggedIn;
    let results = await search.runSortSearch(SEARCH_LIMIT, usePublic, sortField, isAscending);         // true means public
    if (results.errors) {
        // return false;                                                       // show Alert on host page?
        return results;
    }
    searchStore.set(search);                                                // refresh - cannot use $ sytax here

    // API results are now in search.filterResults[]
    // return true;
    return {'errors': false};
}


/*
// this is passed simple data - not a store object
// no Promise returned - this is just a text formatting function
// do not need to getSelectedKeywords() here
export const formatPublicSearchFiltersArray = (serviceData) => {
    const TAX_IDS = [OPEN_ELIG_2022, DEMOGRAPHICS];
    let filters = [];
    if (!serviceData || !serviceData.taxonomies) return [];

    // for (const taxId of TAX_IDS) {
    //     if (serviceData.taxonomies[taxId]) {
    //         filters = [...serviceData.taxonomies[taxId]]
    //     }    
    // }

    if (serviceData.taxonomies[TCARE_TAX_1]) {
        for (const keyword of serviceData.taxonomies[TCARE_TAX_1]) {
            filters.push(keyword);
        }
    }

    if (serviceData.taxonomies[OPEN_ELIG_2022]) {
        for (const keyword of serviceData.taxonomies[OPEN_ELIG_2022]) {
            filters.push(keyword);
        }
    }

    if (serviceData.taxonomies[DEMOGRAPHICS]) {
        for (const keyword of serviceData.taxonomies[DEMOGRAPHICS]) {
            filters.push(keyword);
        }
    }

    //return delimitArray(filters, ', ');                     // utils.js
    return delimitArray(dedupeSimpleArray(filters), ', ');
}
*/



// COMMON EXPLORER MENU FUNCTIONS

export const hasServiceIds = (node) => {
    //console.log('hasServiceIds: ' + node.keyword);
    if (!node) return false;
    return node.serviceIds && node.serviceIds.length > 0;
}

// checks 3 levels of children - no recursion
export const hasChildrenWithServiceIds = (node) => {
    //console.log('hasChildrenWithServiceIds: ' + node.keyword);
    if (!node) return false;
    if (node.children) {
        for (const child1 of node.children) {
            if (hasServiceIds(child1)) return true;
            if (child1.children) {
                for (const child2 of child1.children) {
                    if (hasServiceIds(child2)) return true;
                    if (child2.children) {
                        for (const child3 of child2.children) {
                            if (hasServiceIds(child3)) return true;
                            if (child3.children) {
                                for (const child4 of child3.children) {
                                    if (hasServiceIds(child4)) return true;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    return false;
}

export const firstChildWithServiceIds = (node) => {
    if (!node.children) return null;
    for (const child of node.children) {
        if (hasServiceIds(child)) return child;
    }
    return null;
}

// make sure this is calculated once - not in real team
export const setServiceIdCount = (node) => {
    // console.log('setServiceIdCount: ', node);
    node.serviceIdCount = 0;
    if (node.children) {
        for (const child of node.children) {
            setServiceIdCount(child);
        }
    }
    if (node.serviceIds) node.serviceIdCount = node.serviceIds.length;
    // console.log('node.serviceIdCount: ', node.serviceIdCount);
}


